export default "__VITE_ASSET__B$tzDGJd__"